import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';

const TaskModal = ({ isOpen, onClose, onSave, taskToEdit }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [priority, setPriority] = useState('normal');

  useEffect(() => {
    if (taskToEdit) {
      setTitle(taskToEdit.title || '');
      setDescription(taskToEdit.description || '');
      setDueDate(taskToEdit.dueDate || '');
      setPriority(taskToEdit.priority || 'normal');
    } else {
      setTitle('');
      setDescription('');
      setDueDate('');
      setPriority('normal');
    }
  }, [taskToEdit, isOpen]);

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim()) {
      toast.error("O título da tarefa é obrigatório.");
      return;
    }

    const taskData = {
      title: title.trim(),
      description: description.trim(),
      dueDate,
      priority
    };

    onSave(taskData);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center p-4" onClick={onClose}>
      <div className="max-w-md w-full glass-effect rounded-2xl p-8 border border-white border-opacity-20" onClick={e => e.stopPropagation()}>
        <h2 className="heading-font text-2xl font-bold text-yellow-400 mb-6">
          {taskToEdit ? 'Editar Tarefa' : 'Nova Tarefa'}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label htmlFor="task-title" className="block text-sm font-medium text-yellow-400 mb-1">Título</label>
            <input
              id="task-title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full px-4 py-2 bg-slate-800 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-gold"
              placeholder="Digite o título"
              required
            />
          </div>
          <div>
            <label htmlFor="task-description" className="block text-sm font-medium text-yellow-400 mb-1">Descrição</label>
            <textarea
              id="task-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows={3}
              className="w-full px-4 py-2 bg-slate-800 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-gold"
              placeholder="Adicione mais detalhes..."
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="task-due-date" className="block text-sm font-medium text-yellow-400 mb-1">Data de Vencimento</label>
              <input
                id="task-due-date"
                type="date"
                value={dueDate}
                onChange={(e) => setDueDate(e.target.value)}
                className="w-full px-4 py-2 bg-slate-800 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-gold"
              />
            </div>
            <div>
              <label htmlFor="task-priority" className="block text-sm font-medium text-yellow-400 mb-1">Prioridade</label>
              <select
                id="task-priority"
                value={priority}
                onChange={(e) => setPriority(e.target.value)}
                className="w-full px-4 py-2 bg-slate-800 border border-gray-600 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-primary-gold"
              >
                <option className="bg-slate-900 text-white" value="low">Baixa</option>
                <option className="bg-slate-900 text-white" value="normal">Normal</option>
                <option className="bg-slate-900 text-white" value="high">Alta</option>
              </select>
            </div>
          </div>
          <div className="flex justify-end gap-3 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 bg-slate-700 text-yellow-400 rounded-md hover:bg-slate-600 transition-colors"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="px-4 py-2 gold-gradient text-dark-navy font-semibold rounded-md hover:opacity-90 transition-opacity"
            >
              {taskToEdit ? 'Atualizar' : 'Criar Tarefa'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TaskModal;